import React from "react";

export const HoverButtonContext = React.createContext({
  hoverButtonProps: {
    className: "hover-button"
  },
  setHoverButton: () => {}
});
